import React, { useContext, useEffect, useState } from 'react'
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Divider } from 'primereact/divider';

import Card from '../../../Base/Components/Card/Card';
import Loader from '../../../Base/Components/Loader/Loader';
import AgGrid from '../../../Base/Components/Tables/AgGrid/AgGrid';
import { AuthContext } from '../../../Base/Context/AuthContext/AuthContext';
import { formatNumber } from '../../../Base/Services/TemplatesServices';

import { ResumenVentasAnualesTabla, ResumenVentasMensuales } from '../../../API/Ventas/ResumenVentasRequest';

import { colorCotton, colorSintetico, getTitle, labelPosition } from '../../../utils/KPIs/productionUtils';
import { colors } from '@mui/material';
import { ConfigContext } from '../../../Base/Context/ConfigContext/ConfigContext';

const ResumenVentasMensual = ({ date, kpiGerencia, getDatos, altura }) => {
    const { userAuth } = useContext(AuthContext);
    const [tempoCotton1, setTempoCotton1] = useState(false);
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });
    const { config } = useContext(ConfigContext);
    const colorTitle = getTitle(config);

    let Mes = date.toLocaleString('es-ES', { month: 'long' })
    const monthName = Mes.charAt(0).toUpperCase() + Mes.slice(1);

    const columns = [
        {
            // Customer
            field: 'CustomerName',
            header: 'Customer',
            className: 'colum-width-XXlarge',
            body: (rowData) => rowData.CustomerName,
            Sumary: 'count'
        },
        altura ? 
        {
            // Category
            field: 'StyleCategory',
            header: 'Category',
            body: (rowData) => rowData.StyleCategory,
            align: 'center',
            className: 'colum-width-small',
            hidden: userAuth?.IdRol === -5
        } :         
        {
            // Category
            field: 'StyleCategory',
            header: 'Category',
            body: (rowData) => rowData.StyleCategory,
            align: 'center',
        },
        {
            field: 'Año',
            header: 'Año',
            className: 'colum-width-small',
            body: (rowData) => rowData.Año,
            align: 'center',
        },
        {
            // MesD
            field: 'MesD',
            header: 'Mes',
            className: 'colum-width-medium',
            body: (rowData) => rowData.MesD,
            align: 'center',
        },
        {
            // Rollos
            field: 'Rollos',
            header: 'Rollos',
            className: 'colum-width-small',
            body: (rowData) => rowData.Rollos,
            Format: 'Currency',
            Sumary: 'sum',
            frozen: 'frozen',
            alignFrozen: 'right',
        },
        {
            // Yds
            field: 'Yds',
            header: 'Yds',
            className: 'colum-width-small',
            body: (rowData) => rowData.Yds,
            Format: 'Currency',
            Sumary: 'sum'
        },
        {
            // Kgs
            field: 'Kgs',
            header: 'Kgs',
            className: 'colum-width-small',
            body: (rowData) => rowData.Kgs,
            Format: 'Currency',
            Sumary: 'sum',
            frozen: 'frozen',
            alignFrozen: 'right',
        },
        {
            // Lbs
            field: 'Lbs',
            header: 'Lbs',
            className: 'colum-width-small',
            body: (rowData) => rowData.Lbs,
            Format: 'Currency',
            Sumary: 'sum'
        },
        {
            // AmountToPay
            field: 'AmountT',
            header: 'Real ($)',
            className: 'colum-width-small',
            body: (rowData) => rowData.AmountT,
            Format: 'Currency',
            Sumary: 'sum',
            frozen: 'frozen',
            alignFrozen: 'right',
        },
    ]

    const optionsChart = {
        interaction: {
            mode: 'index', 
            intersect: false,
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                align: 'start',
                anchor: 'start',
                offset: 5,
                color: colorTitle,
                font: {
                    size: 10,
                },
                formatter: (value) => {
                    return value > 0 ? '$ ' + formatNumber(value).replace('.00', '') : '';
                },
            },
            legend: {
                position: 'bottom',
                labels: {
                    color: colorTitle,
                    font: {
                        size: 11,
                    },
                },
            },
            tooltip: {
                callbacks: {
                  footer: (tooltipItems) => {
                    const index = tooltipItems[0].dataIndex;
                    const porcentaje = tooltipItems[1]?.dataset?.data2[index];
                    return `Cumplimiento: ${porcentaje} %`;
                  },
                },
            },
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: colorTitle,
                    minRotation: 90,
                    maxRotation: 90,
                    font: {
                        size: 10,
                    },
                },
            },
            y: {
                ticks: {
                    color: colorTitle,
                    callback: (val, index) => {
                        return val > 0 ? '$ ' + formatNumber(val).replace('.00', '') : '';
                    },
                },
            },
        },
    };

    const datalabelsVentas =  {
        borderRadius: 4,
        align: labelPosition,
        anchor: labelPosition,
        borderWidth: 2,
        marginButtom: 10,
        padding: 6,
        offset: 5,
        font: {
            weight: 'bold',
            size:11
        },
        color: (context) => {
            if (context.datasetIndex === 1) {
                return colorTitle
            } else {
                return colors.pink[800];
            }
        },
        
        formatter: (value) => {
            if (value === 0 || value === null) {
                return null
            }
            return "$ " + (value / 1000000).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " M"
        },
    }
    

    const [loading, setLoading] = useState(false);
    const [chartCotton, setChartCotton] = useState({
        data: {},
        options: {}
    });
    const [tableCotton, setTableCotton] = useState({
        Data: [],
        Columns: columns,
        key: 'IdCustomer',
        filter: false,
        className: 'mt-3'
    })

    const [chartPoly, setChartPoly] = useState({
        data: {},
        options: {}
    });
    const [tablePoly, setTablePoly] = useState({
        Data: [],
        Columns: columns,
        key: 'IdCustomer',
        filter: false,
        className: 'mt-3'
    })

    const getResumenVentas = async () => {
        setChartCotton({
            data: {},
            options: {}
        });
        setChartPoly({
            data: {},
            options: {}
        });
        setTableCotton({
            Data: [],
            Columns: columns,
            key: 'IdCustomer',
            filter: false,
            className: 'mt-3'
        })
        setTablePoly({
            Data: [],
            Columns: columns,
            key: 'IdCustomer',
            filter: false,
            className: 'mt-3'
        })
        setLoading(true);
        const tempoCotton = await ResumenVentasMensuales({ year: date.getFullYear(), Mes: date.getMonth() + 1, IdCategory: 1 });
        const tempoCotton1Tempo = await ResumenVentasAnualesTabla({ year: date.getFullYear(), Mes: date.getMonth() + 1});
        setTempoCotton1(tempoCotton1Tempo)
        const tempoPoly = await ResumenVentasMensuales({ year: date.getFullYear(), Mes: date.getMonth() + 1, IdCategory: 2 });

        let labelsCotton = [];
        let valuesCotton = [];
        let presupuestoCo = [];
        let porcentajeCumpliCo = [];

        let labelPoly = [];
        let valuesPoly = [];
        let presupuestoPo = [];
        let porcentajeCumpliPo = [];

        let combinedArrayCotton = tempoCotton.map(element => ({
            CustomerName: element.CustomerName,
            Ventas: element.Ventas,
            Presupuesto: element.Presupuesto,
            PorcentajeCumplimiento: element.PorcentajeCumplimiento
        }));

        labelsCotton.length = 0;
        valuesCotton.length = 0;
        presupuestoCo.length = 0;
        porcentajeCumpliCo.length = 0;

        combinedArrayCotton.forEach(element => {
            labelsCotton.push(element.CustomerName);
            valuesCotton.push(element.Ventas);
            presupuestoCo.push(element.Presupuesto);
            porcentajeCumpliCo.push(element.PorcentajeCumplimiento);
        });

        let combinedArray = tempoPoly.map(element => ({
            CustomerName: element.CustomerName,
            Ventas: element.Ventas,
            Presupuesto: element.Presupuesto,
            PorcentajeCumplimiento: element.PorcentajeCumplimiento
        }));

        labelPoly.length = 0;
        valuesPoly.length = 0;
        presupuestoPo.length = 0;
        porcentajeCumpliPo.length = 0;
        
        combinedArray.forEach(element => {
            labelPoly.push(element.CustomerName);
            valuesPoly.push(element.Ventas);
            presupuestoPo.push(element.Presupuesto);
            porcentajeCumpliPo.push(element.PorcentajeCumplimiento);
        });

        setChartCotton({
            data: {
                labels: labelsCotton,
                datasets: [
                    {
                        type: 'line',
                        label: 'Budget',
                        backgroundColor: colors.pink[800],
                        borderColor: colors.pink[800],
                        data: presupuestoCo,
                        borderDash: [5, 5], 
                        datalabels: datalabelsVentas,
                    },
                    {
                        type: 'bar',
                        label: 'Cotton',
                        backgroundColor: colorCotton,
                        borderColor: colorCotton,
                        data: valuesCotton,
                        data2: porcentajeCumpliCo,
                        datalabels: datalabelsVentas,
                    },
                ],
            }
        });

        setTableCotton({
            ...tableCotton,
            Data: altura ? tempoCotton1 :tempoCotton,
            scrollHeight: (tempoCotton.length * 33.02) + 26 + 32 + 'px',
        })

        setChartPoly({
            data: {
                labels: labelPoly,
                datasets: [
                    {
                    type: 'line',
                    label: 'Budget',
                    backgroundColor: colors.pink[800],
                    borderColor: colors.pink[800],
                    data: presupuestoPo,
                    borderDash: [5, 5],
                    datalabels: datalabelsVentas,
                    },
                    {
                    type: 'bar',
                    label: 'Synthetic',
                    backgroundColor: colorSintetico,
                    borderColor: colorSintetico,
                    data: valuesPoly,
                    data2: porcentajeCumpliPo,
                    datalabels: datalabelsVentas,
                    },
                ],
            },
        })

        setTablePoly({
            ...tablePoly,
            Data: tempoPoly,
            scrollHeight: (tempoPoly.length * 33.02) + 26 + 32 + 'px',
        })
        setLoading(false);
    }

    const columns1 = [
        {
            // Customer
            field: 'IdCustomer',
            header: 'ID',
            className: 'XXsmall',
            Sumary: 'count',
            hidden: userAuth?.IdRol === 1,
            frozen: 'frozen',
            alignFrozen: 'left',
        },
        {
            // Customer
            field: 'CustomerName',
            header: 'Customer',
            className: 'colum-width-XXlarge',
            body: (rowData) => rowData.CustomerName,
            Sumary: 'count',
            frozen: 'frozen',
            alignFrozen: 'left',
        },
        {
            // Rollos
            field: 'RollosCotton',
            header: 'Rollos Cotton',
            className: 'colum-width-small',
            body: (rowData) => rowData.RollosCotton,
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            // Rollos
            field: 'RollosSynthetic',
            header: 'Rollos Synthetic',
            className: 'colum-width-small',
            body: (rowData) => rowData.RollosSynthetic,
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            // Rollos
            field: 'RollosT',
            header: 'Rollos Totales',
            className: 'colum-width-small',
            body: (rowData) => rowData.RollosT,
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            // Kgs
            field: 'KgsCotton',
            header: 'Kgs Cotton',
            className: 'colum-width-small',
            body: (rowData) => rowData.KgsCotton,
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            // Kgs
            field: 'KgsSynthetic',
            header: 'Kgs Synthetic',
            className: 'colum-width-small',
            body: (rowData) => rowData.KgsSynthetic,
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            // Kgs
            field: 'KgsT',
            header: 'Kgs Totales',
            className: 'colum-width-small',
            body: (rowData) => rowData.KgsT,
            Format: 'Currency',
            Sumary: 'sum',
            frozen: 'frozen',
            alignFrozen: 'right',
        },
        {
            // AmountToPay
            field: 'AmountTCotton',
            header: 'Total Cotton',
            className: 'colum-width-small',
            body: (rowData) => rowData.AmountTCotton,
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            // AmountToPay
            field: 'AmountTSynthetic',
            header: 'Total Synthetic',
            className: 'colum-width-small',
            body: (rowData) => rowData.AmountTSynthetic,
            Format: 'Currency',
            Sumary: 'sum',
        },
        {
            // AmountToPay
            field: 'AmountT',
            header: 'Real ($)',
            className: 'colum-width-small',
            body: (rowData) => rowData.AmountT,
            Format: 'Currency',
            Sumary: 'sum',
            frozen: 'frozen',
            alignFrozen: 'right',
        },
    ]


    const tableT = {
        Data: tempoCotton1,
        Columns: columns1
    };


    useEffect(() => {
        getResumenVentas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        getResumenVentas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [date])

    useEffect(() => {
        const handleResize = () => {
          setScreenSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        };
      
        window.addEventListener('resize', handleResize);
        
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);
      

    useEffect(() => {
        if (getDatos) {
            getResumenVentas()
        }
    }, [getDatos])

    console.log(screenSize)

    let si = screenSize?.width


    return (
        <div  style={{ height: altura ? '80vh' : '100vh' }} id='resumenVentasMensual'>
            <Loader loading={loading} querySelector={'#resumenVentasMensual'} />
            {kpiGerencia ? (<div>
                
                <Card
                    titulo={<h4>{`Ventas mensuales (${monthName} / ${date.getFullYear()}) ($)`}</h4>}
                    contenido={
                        altura ?


                        <div className='d-flex flex-row gap-4' style={{ justifyContent: 'space-between'}}>
                            <Chart style={{ width: '80%', height: '100%' }} data={chartCotton.data} options={optionsChart} plugins={[ChartDataLabels]} />
    
                            <Divider layout="vertical" style={{ height: '35vh', alignSelf: 'center', backgroundColor: '#edeff0', width: '1px' }} />
                            
                            <Chart style={{ width: '80%', height: '100%' }} data={chartPoly.data} options={optionsChart} plugins={[ChartDataLabels]} />
                        </div> 

                        : 
                        <div className='p-3' style={{ display: 'flex' }}>
                            <div style={{ width: '50%' }}>
                                <Chart height='100%' data={chartCotton.data} options={optionsChart} plugins={[ChartDataLabels]} />
                            </div>
                            <div style={{ width: '50%' }}>
                                <Chart height='100%' data={chartPoly.data} options={optionsChart} plugins={[ChartDataLabels]} />
                            </div>
                        </div> 
                    }
                />
                
                {
                    altura ?
                    <div  style={{ display: 'flex', gap: 10}} className='mt-4'>
                        <div style={{ width: '100%', height: altura ? '43vh' : '50vh' }}>
                            <AgGrid table={tableT} />
                        </div>
                    </div> 
                    :
                    <div>
                        <Card
                            titulo={<h3>{''}</h3>}
                            contenido={
                                <div  style={{ display: 'flex', gap: 10}}>
                                    <div style={{ width: '50%', height: altura ? '45vh' : '50vh' }}>
                                        <AgGrid table={tableCotton} />
                                        {/* <DevExpress table={tableCotton} /> */}
                                    </div>
                                    <div style={{ width: '50%', height: altura ? '45vh' : '50vh'  }}>
                                        <AgGrid table={tablePoly} />
                                        {/* <DevExpress table={tablePoly} /> */}
                                    </div>
                                </div>
                            }
                        />
                    </div>
                }





            </div>)
                : (
                    <div>
                        <div>
                            <Card
                                titulo={<h3>{ 'Mensual Cotton'}</h3>}
                                contenido={
                                    <div className='p-3' style={kpiGerencia ? { display: 'flex' } : {}}>
                                        <div >
                                            <Chart height='75vh' data={chartCotton.data} options={optionsChart} plugins={[ChartDataLabels]} />
                                        </div>
                                        <div  style={{height:'50vh'}}>
                                            <AgGrid table={tableCotton} />
                                            {/* <DevExpress table={tableCotton} /> */}
                                        </div>
                                    </div>
                                }
                            />
                        </div>
                        <div>
                            <Card
                                titulo={<h3>{ 'Mensual Synthetic'}</h3>}
                                contenido={
                                    <div className='p-3' style={kpiGerencia ? { display: 'flex', gap: 10 } : {}}>
                                        <div>
                                            <Chart height='75vh' data={chartPoly.data} options={optionsChart} plugins={[ChartDataLabels]} />
                                        </div>
                                        <div style={{height:'50vh'}}>
                                            <AgGrid  table={tablePoly} />
                                            {/* <DevExpress table={tablePoly} /> */}
                                        </div>
                                    </div>
                                }
                            />
                        </div>
                    </div>
                )}
        </div>
    );
};

export default ResumenVentasMensual;
